const internalTools = 'internalTools';

/** Base Fetch Actions */
export const UPDATE_CUSTOM_EVENT_LIMIT_REQUEST = `${internalTools}/UPDATE_CUSTOM_EVENT_LIMIT_REQUEST`;
export const UPDATE_CUSTOM_EVENT_LIMIT_RESPONSE = `${internalTools}/UPDATE_CUSTOM_EVENT_LIMIT_RESPONSE`;
export const UPDATE_CUSTOM_EVENT_LIMIT_ERROR = `${internalTools}/UPDATE_CUSTOM_EVENT_LIMIT_ERROR`;

export const FETCH_PROJECT_LIMIT_DATA_REQUEST = `${internalTools}/FETCH_PROJECT_LIMIT_DATA_REQUEST`;
export const FETCH_PROJECT_LIMIT_DATA_RESPONSE = `${internalTools}/FETCH_PROJECT_LIMIT_DATA_RESPONSE`;
export const FETCH_PROJECT_LIMIT_DATA_ERROR = `${internalTools}/FETCH_PROJECT_LIMIT_DATA_ERROR`;
